<template>
  <div class="flex h-full flex-col justify-between">
    <TransactionsList
      :transactions="transactions"
      class="mb-2"
    />
    <RouterLink
      :to="{ name: 'historyTransactions' }"
      class="text-primary flex-shrink-0 text-sm"
    >
      view all transactions
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
const { pagination } = usePagination({
  limit: 5,
  count: computed(() => data.value?.count || 0),
})

const query = reactiveComputed(() => ({
  ...pagination.value,
}))

const { data } = useTransactions(query)

const transactions = computed(() => data.value?.items || [])
</script>
